import { initArticleSearchAutocomplete } from '../../utils/article-search-autocomplete';
import { initAllSuggestionsScrollbars } from '../../utils/suggestions-scrollbar';

const ROOT_SELECTOR = '.header-with-search';
const INPUT_SELECTOR = '.header-with-search__input';
const SUBMIT_SELECTOR = '.header-with-search__submit';
const SUGGESTIONS_SELECTOR = '.header-with-search__suggestions';

export function initHeaderWithSearch(): void {
  document.querySelectorAll<HTMLElement>(ROOT_SELECTOR).forEach(initHeaderWithSearchRoot);
  initAllSuggestionsScrollbars();
}

function getSubmitUrl(root: HTMLElement): URL | null {
  if (root.dataset.searchLink) {
    return new URL(root.dataset.searchLink, window.location.origin);
  }

  if (root.classList.contains('header-with-search--search-results')) {
    return new URL(window.location.href);
  }

  return null;
}

function navigateToSearch(root: HTMLElement, query: string): void {
  const trimmedQuery = query.trim();
  if (!trimmedQuery) return;

  const submitUrl = getSubmitUrl(root);
  if (!submitUrl) return;

  submitUrl.searchParams.set('q', trimmedQuery);
  window.location.href = submitUrl.toString();
}

const SUGGESTIONS_ID = 'header-with-search-suggestions';

function initSearchFieldAccessibility(
  searchInput: HTMLInputElement,
  submitButton: HTMLButtonElement | null,
  suggestionsList: HTMLUListElement | null,
): void {
  if (suggestionsList && !suggestionsList.id) {
    suggestionsList.id = SUGGESTIONS_ID;
  }

  searchInput.setAttribute('role', 'combobox');
  searchInput.setAttribute('aria-autocomplete', 'list');

  if (!searchInput.getAttribute('aria-expanded')) {
    searchInput.setAttribute('aria-expanded', 'false');
  }

  if (suggestionsList?.id) {
    searchInput.setAttribute('aria-controls', suggestionsList.id);
  }

  submitButton?.setAttribute('role', 'button');
}

function initHeaderWithSearchRoot(root: HTMLElement): void {
  const searchInput = root.querySelector<HTMLInputElement>(INPUT_SELECTOR);
  const submitButton = root.querySelector<HTMLButtonElement>(SUBMIT_SELECTOR);
  const suggestionsList = root.querySelector<HTMLUListElement>(SUGGESTIONS_SELECTOR);

  if (!searchInput) return;

  initSearchFieldAccessibility(searchInput, submitButton, suggestionsList);

  if (suggestionsList && root.dataset.searchStaticSuggestions !== 'true') {
    initArticleSearchAutocomplete({
      root,
      input: searchInput,
      suggestionsList,
    });
  }

  const handleSubmit = (event?: Event): void => {
    event?.preventDefault();
    navigateToSearch(root, searchInput.value);
  };

  searchInput.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    if (searchInput.getAttribute('aria-expanded') === 'true' && searchInput.getAttribute('aria-activedescendant')) {
      return;
    }
    event.preventDefault();
    handleSubmit();
  });

  submitButton?.addEventListener('click', handleSubmit);
}
